module.exports = __webpack_public_path__ + "static/PingCheng-9f38af9fa5b57dcd1594925446fd07e1.pdf";